import { FC, useEffect, useState } from 'react'
import { useGetSsccXmlRetriggeredList } from 'framework/api/methods/ssccXml/useGetSsccXmlRetriggeredList'

import { formatSsccXmlDate } from './ssccXmlFormat'
import { SsccXmlColumn, SsccXmlTable } from './SsccXmlTable'

export interface SsccXmlFileRow {
  id: string
  orderNumber: string
  orderDate?: string | null
  fileName: string
  source?: string | null
}

export interface SsccXmlRetriggeredTabProps {
  search: string
  refreshKey?: number
}

export const fileColumns: SsccXmlColumn<SsccXmlFileRow>[] = [
  {
    key: 'orderNumber',
    header: 'Order ID',
    width: '260px',
    render: (row) => (
      <span className='font-bold text-[#2A2A2D]'>{row.orderNumber}</span>
    ),
  },
  {
    key: 'orderDate',
    header: 'Order Date',
    width: '160px',
    render: (row) => formatSsccXmlDate(row.orderDate),
  },
  {
    key: 'fileName',
    header: 'SSCC XML File Name',
    width: 'minmax(0,1fr)',
    render: (row) => (
      <span className='font-mono text-[13px] break-all'>{row.fileName}</span>
    ),
  },
]

/** BDL20-3999: Retriggered SSCC XML — read-only, newest retrigger first, one row per retrigger. */
export const SsccXmlRetriggeredTab: FC<SsccXmlRetriggeredTabProps> = ({
  search,
  refreshKey,
}: SsccXmlRetriggeredTabProps) => {
  const [pageSize, setPageSize] = useState(10)
  const [pageNumber, setPageNumber] = useState(1)

  useEffect(() => setPageNumber(1), [search, pageSize])

  const { data, isLoading, refetch } = useGetSsccXmlRetriggeredList({
    search,
    take: pageSize,
    skip: (pageNumber - 1) * pageSize,
  })

  useEffect(() => {
    if (refreshKey) refetch()
  }, [refreshKey])

  return (
    <SsccXmlTable
      columns={fileColumns}
      rows={data?.items ?? []}
      rowKey={(row) => row.id}
      totalCount={data?.totalCount ?? 0}
      pageSize={pageSize}
      pageNumber={pageNumber}
      isLoading={isLoading}
      onPageChange={setPageNumber}
      onPageSizeChange={setPageSize}
    />
  )
}

export default SsccXmlRetriggeredTab
